import React, { useState, useEffect } from 'react';
import './UserSearch.css';

interface User {
  userId: string;
  email: string;
  name?: string;
}

interface UserSearchProps {
  onUserSelect: (user: User) => void;
  selectedUser?: User | null;
  placeholder?: string;
  className?: string;
}

const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const UserSearch: React.FC<UserSearchProps> = ({
  onUserSelect,
  selectedUser,
  placeholder = "Enter email address...",
  className = ''
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (selectedUser) {
      setSearchQuery(selectedUser.email);
    }
  }, [selectedUser]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (selectedUser && value !== selectedUser.email) {
      onUserSelect(null as any);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && isValidEmail(searchQuery)) {
      onUserSelect({ userId: searchQuery, email: searchQuery });
    }
  };

  const handleBlur = () => {
    if (!selectedUser && isValidEmail(searchQuery)) {
      onUserSelect({ userId: searchQuery, email: searchQuery });
    }
  };

  return (
    <div className={`user-search ${className}`}>
      <div className="user-search-container">
        <input
          type="email"
          className="form-control"
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
        />
      </div>

      {selectedUser && (
        <div className="selected-user mt-2">
          <div className="alert alert-info">
            <div className="selected-user-content">
              <div className="user-avatar">
                {selectedUser.email.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                <strong>{selectedUser.email}</strong>
              </div>
              <button
                type="button"
                className="btn-clear"
                onClick={() => {
                  setSearchQuery('');
                  onUserSelect(null as any);
                }}
                title="Clear selection"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSearch;
